.metricBar {
  display: block;
  width: 100%;
  height: auto;
  user-select: none;
}
